import Register from 'views/register/Register.container';

export default Register;
